import { render, staticRenderFns } from "./PersonalMobileWallpaperDetail.vue?vue&type=template&id=55db39e2&scoped=true&"
import script from "./PersonalMobileWallpaperDetail.vue?vue&type=script&lang=js&"
export * from "./PersonalMobileWallpaperDetail.vue?vue&type=script&lang=js&"
import style0 from "./PersonalMobileWallpaperDetail.vue?vue&type=style&index=0&id=55db39e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55db39e2",
  null
  
)

export default component.exports